module.exports = __webpack_public_path__ + "static/media/threedot.4ca585d4.png";